import { useEffect, useState } from 'react';
import { apiFetch } from '../lib/api.js';

interface StreamInfo {
  live: boolean;
  viewerCount: number | null;
  gameName: string | null;
  title: string | null;
  youtubeLive: boolean;
  youtubeViewerCount: number | null;
  updatedAt: number;
}

const POLL_MS = 30_000;

export function useStreamInfo(): StreamInfo {
  const [info, setInfo] = useState<StreamInfo>({
    live: false,
    viewerCount: null,
    gameName: null,
    title: null,
    youtubeLive: false,
    youtubeViewerCount: null,
    updatedAt: 0,
  });

  useEffect(() => {
    let cancelled = false;
    const fetch = async () => {
      try {
        const data = await apiFetch<StreamInfo>('/api/config/stream');
        if (!cancelled) setInfo(data);
      } catch {
        // silently ignore — non-critical
      }
    };
    void fetch();
    const timer = setInterval(() => { void fetch(); }, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, []);

  return info;
}
